import { Form } from 'react-bootstrap';
import MobileNumberInput from './MobileNumberInput';
import './Form.css';

Form.defaultProps = {
    className: ""
};

Form.Group.defaultProps = {
    className: "input-group"
};

Form.Label.defaultProps = {
    className: "input-label"
};

Form.Control.defaultProps = {
    className: "rounded-0 shadow-0 input-control"
};

Form.Text.defaultProps = {
    className: ""
};

Form.Check.defaultProps = {
    className: "rounded-0 input-check",
    custom: true
};

Form.MobileNumberInput = MobileNumberInput;

export default Form;